import { createContext, useContext } from 'react';

const ServerContext = createContext(false);

export const ServerProvider = ServerContext.Provider;

export function useIsServer(): boolean {
  return useContext(ServerContext);
}
